import { useEffect, useState,useContext } from "react";
import {
    Image,
    Text,
    Link,
    VStack,
    Button,
    CloseIcon
  } from "native-base";
import { useNavigate,useLocation } from "react-router-dom";
import StyledImage from "../../components/Image";

function PinkCaring() {
    // var careImage = require('../images/careImage.png');
    const navigate = useNavigate();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const CareImg = require("./care.png");


        
    return (
      <>
            <VStack
              alignItems="flex-start"
              space={0}
              px={"4"}
              paddingTop={"4"}
              marginBottom={"4"}
            >
              <Button onPress={() => navigate(-1)} variant={"unstyled"}>
                <CloseIcon color={'black'} size={"4"} />
              </Button>
            </VStack>
            <VStack alignItems={"center"} marginBottom={"8"}>
              <Text
                color={'black'}
                fontSize={'32px'} 
                fontFamily={'Unna'}
                letterSpacing={"0.46px"}
              >
                Care
              </Text>
            </VStack>
            <VStack alignItems={"center"} space={0} px={"4"} marginBottom={8}>
              <Text
                 color={'black'}
                 fontSize={'12px'} 
                 fontFamily={'Unna'}
                 fontWeight={'300'}
              >
                This vest has been made with upcycled material to be worn by you for many years to come. To ensure the delicate fabric can last you longer, we have a few tips to keep your vest in the best possible shape.
              </Text>
            </VStack>

            <div>
                  <VStack alignItems={"flex-start"} px={"4"}  marginTop={'24px'}>
                      <Text
                          color={'#9D7C07'}
                          fontSize={'15px'}
                          letterSpacing={"3px"}
                          textTransform={"uppercase"}
                          fontFamily={'Unna'}
                        >
                          WASH
                      </Text>
                      <VStack marginTop={'4px'} fontFamily={'Unna'}>       
                              <Text
                                color={'black'}
                                fontSize={'12px'}
                                marginTop={'4px'}
                                fontFamily={'Unna'}
                              >
                                As this is a delicate fabric, we recommend very delicately washing by hand in the sink with delicate detergent in warm water.
                              </Text>
                              <Text
                                color={'black'}
                                fontSize={'12px'}
                                marginTop={'4px'}
                                fontFamily={'Unna'}
                              >
                               If you must put it in the washing machine, put it on delicate cycle in cold water with delicate detergent, and in a mesh fabric bag.
                              </Text>
                      </VStack>

                  </VStack>

                  <VStack alignItems={"flex-start"} px={"4"}  marginTop={'24px'}>
                      <Text
                          color={'#9D7C07'}
                          fontSize={'15px'}
                          letterSpacing={"3px"}
                          textTransform={"uppercase"}
                          fontFamily={'Unna'}
                        >
                          DRYING
                      </Text>
                      <VStack marginTop={'4px'}>       
                              <Text
                                color={'black'}
                                fontSize={'12px'}
                                marginTop={'4px'}
                                fontFamily={'Unna'}
                              >
                              Do not put in the dryer. Lay flat on a drying rack to dry.
                              </Text>
                      </VStack>

                  </VStack>

                  <VStack alignItems={"flex-start"} px={"4"}  marginTop={'24px'}>
                      <Text
                          color={'#9D7C07'}
                          fontSize={'15px'}
                          letterSpacing={"3px"}
                          textTransform={"uppercase"}
                          fontFamily={'Unna'}
                        >
                          STAINS
                      </Text>
                      <VStack marginTop={'4px'}>       
                            <Text
                              color={'black'}
                              fontSize={'12px'}
                              marginTop={'4px'}
                              fontFamily={'Unna'}
                            >
                             <strong>Wine & coffee stains:</strong>  We recommend using an organic dish soap as soon as you see the stain, then wash under warm water in the sink carefully rubbing at the stain with your fingers.
                             If in the U.S., there is also a product called “Wine Away” that works well by spraying at the stain. 
                            </Text>
                      </VStack>
                      <VStack marginTop={'4px'}>       
                            <Text
                              color={'black'}
                              fontSize={'12px'}
                              marginTop={'4px'}
                              fontFamily={'Unna'}
                            >
                             <strong>Grease stains:</strong>  
                             apply baking soda or salt to the spot right away and let sit for one hour to let them absorb the grease, and then wipe away with a warm white rag. Repeat if needed. Then wash in warm water with delicate detergent and a spot treatment on the spot.
                            </Text>
                      </VStack>
                      <VStack marginTop={'4px'}>       
                            <Text
                              color={'black'}
                              fontSize={'12px'}
                              marginTop={'4px'}
                              fontFamily={'Unna'}
                            >
                             <strong>Blood stains:</strong>  
                             treat this as soon as possible by using a sponge or your fingers and delicately wash the blood away first. Then use diluted white vinegar to treat the stain by delicately patting the spot with a warm cloth, then wash the garment.
                            </Text>
                      </VStack>
                      <VStack marginTop={'4px'}>       
                            <Text
                              color={'black'}
                              fontSize={'12px'}
                              marginTop={'4px'}
                              fontFamily={'Unna'}
                            >
                             <strong>Wax droppings:</strong>  
                             freeze the garment in a sealed bag for 1 day, and carefully use your nails or a non-sharp blade to carefully remove the wax.
                            </Text>
                      </VStack>
                  </VStack>
              </div>
          
            <VStack alignItems={"center"} marginBottom={5} marginTop={10}>
              <StyledImage
                width="60%"
                src={CareImg}
                alt={"Image of the product design 2"}
              />
            </VStack>
      </>
        
    );
  }
  
  export default PinkCaring;
  